// Import viewer
// TODO => Rename DefaultViewer en DefaultViewer
import DefaultViewer from './DefaultViewer';
import PdfViewer from './PdfViewer';

// Register default viewers
const registeredViewers = new Map();
// TODO remplacer par le type MIME plutôt que l'extension une fois la data dispo
registerViewer('png', DefaultViewer);
registerViewer('jpeg', DefaultViewer);
registerViewer('jpg', DefaultViewer);
registerViewer('tiff', DefaultViewer);
registerViewer('tif', DefaultViewer);
registerViewer('pdf', PdfViewer);

/**
 * Register viewer component under specified name
 *
 * @param {String} name - Component identification
 * @param {Object} viewer - component viewer
 */
export function registerViewer(name, viewer) {
  registeredViewers.set(name, viewer);
}

/**
 * Retrieve viewer component
 * @param {String} name - viewer component identification.
 * @returns {Function} Returns viewer component
 */
export function getViewer(name = null) {
  if (name) {
    name = name.toLowerCase();
  }
  if (!name || !registeredViewers.has(name)) {
    // If haven't registered viewer return default viewer
    return DefaultViewer;
  }
  return registeredViewers.get(name);
}

/**
 * Retrieve list of names registered from the collection
 *
 * @returns {IterableIterator<string>} Returns an array of strings with all viewer component names stored.
 */
export function getViewers() {
  return registeredViewers.keys();
}
